"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

type EventData = {
  "Storefront: User Viewed Page": {
    /**
     * The URL of the page that was viewed.
     */
    url: string;
  };
};

/**
 * Track an event with Amplitude.
 *
 * Note: When introducing a new type of event, make sure to add it to the
 * `EventData` type.
 *
 * This function is available on the client only.
 *
 * @param event The event name.
 * @param data The event data.
 */
export const track = <E extends keyof EventData>(event: E, data: EventData[E]) => {
  if (typeof window === "undefined") return;

  // Post to /api/track/
  fetch("/api/track/", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      event,
      data,
    }),
  });
};

/**
 * This component tracks page views with Amplitude.
 */
export const Tracker = () => {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window !== "undefined") {
      track("Storefront: User Viewed Page", {
        url: pathname,
      });
    }
  }, [pathname]);

  return null;
};
